export default {
      id: "Expenses-of-visiting-usage",
      viewBox: "0 0 45 45",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#Expenses-of-visiting",
      toString: function () {
        return this.url;
      }
    }